// extracted by mini-css-extract-plugin
module.exports = {"container":"_7a3fb80146--container--_PF22","icon":"_7a3fb80146--icon--GYbz7"};